export default "__VITE_ASSET__BMz9eihC__"